module.exports = __webpack_public_path__ + "static/media/main_card04_n.89c00009.png";